<template>
  <div class="chart_warp">
    <div class="chart_tool">
      <el-button class="def_btn tool_icon_btn" plain size="small" icon="el-icon-full-screen" @click="fullScreen">
      </el-button>
      <el-select size="small" v-model="dialogTitle" placeholder="请选择" @change="changeChart">
        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="chart_cont" ref="supply"></div>
    <!-- 全屏显示图表 -->
    <el-dialog :title="dialogTitle" custom-class="big_dialog" top="0" :visible.sync="fullVisible" width="100%">
      <el-select size="small" v-model="dialogTitle" placeholder="请选择" @change="changeChart">
        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <div class="chart_cont" ref="full_supply"></div>
    </el-dialog>
  </div>
</template>

<script>
import { formatInt } from '@/api/portrait.js'
import 'echarts/map/js/china.js'
export default {
  props: {
    chartInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      myChart: null,
      fullVisible: false,
      dialogTitle: '备案人员分布',
      typeOptions: [
        { label: '终端分布', value: '终端分布' },
        { label: '备案人员分布', value: '备案人员分布' }
      ],
      mapData: null,
      option: {
        // 提示浮窗样式
        tooltip: {
          trigger: "item",
          showDelay: 0,
          transitionDuration: 0.2
        },
        visualMap: {
          type: 'piecewise',
          left: 'left',
          min: 0,
          max: 50,
          inRange: {
            color: ['#81BBBD', '#4FA1A4', '#4F77A4']
          },
          inverse: true,
          itemWidth: 18,
          itemHeight: 15,
          itemSymbol: 'rect',
          // itemGap: 0,
          calculable: false
        },
        series: [
          {
            type: 'map',
            map: 'china',
            center: [100.34, 36.53],
            zoom: 1.5,
            // 地图文字
            label: {
              // 通常状态下的样式
              normal: {
                // 默认是否显示地区名称
                // textStyle: {
                //     color: 'black'
                // }
              },
              // 鼠标放上去的样式
              emphasis: {
                textStyle: {
                  color: 'red'
                }
              }
            },
            // 地图区域的样式设置
            itemStyle: {
              normal: {
                // 地图边界颜色
                borderColor: '#fff',
                // 地图区域背景颜色
                areaColor: '#eee',
              },
              // 鼠标放上去高亮的样式
              emphasis: {
                // 鼠标放上去地图区域背景颜色
                areaColor: '#67AFF9',
                borderWidth: 0
              }
            },
            data: []
          }
        ]
      },
      terminals: [],
      staffs: [],
      maxArr: {},
      animationDuration: 100,
      animationDurationUpdate: 0,
    }
  },
  beforeDestroy() {
    this.myChart && this.myChart.clear()
  },
  methods: {
    async setOption(val) {
      let seriesList = val, _this = this;
      for (var i in seriesList) {
        let item = seriesList[i] ? seriesList[i] : []
        let itemMax = Math.max.apply(null, item.values)
        this.maxArr[i] = itemMax
        if (i == 'terminals') {
          if (item && item.names && item.names.length) {
            let term = item.names
            term.map((it, m) => {
              let tname = _this.setProvName(it)
              this.terminals.push({
                name: tname,
                value: item.values[m]
              })
            })
          } else {
            this.terminals = []
          }
        } else {
          if (item && item.names && item.names.length) {
            let term = item.names
            term.map((it, m) => {
              let tname = _this.setProvName(it)
              this.staffs.push({
                name: tname,
                value: item.values[m]
              })
            })
          } else {
            this.staffs = []
          }
        }
      }
      this.changeChart()
    },
    setProvName(name) {
      let tname = ''
      if (name.indexOf('市') > -1) {
        tname = name.replace('市', '');
      } else if (name.indexOf('省') > -1) {
        tname = name.replace('省', '');
      } else if (name.indexOf('自治区') > -1) {
        if (name == '内蒙古自治区') {
          tname = '内蒙古'
        } else if (name == "广西壮族自治区") {
          tname = '广西'
        } else if (name == "宁夏回族自治区") {
          tname = '宁夏'
        } else if (name == "新疆维吾尔自治区 ") {
          tname = '新疆'
        } else if (name == "西藏自治区") {
          tname = '西藏'
        }
      } else {
        tname = name.slice(0, 2)
      }
      return tname;
    },
    changeChart() {
      let max = this.dialogTitle.indexOf('终端') > -1 ? this.maxArr.terminals : this.maxArr.staffs
      this.option.visualMap.max = max <= 50 ? 50 : formatInt(max, true)
      if (this.dialogTitle.indexOf('终端') > -1) {
        this.option.series[0].name = '终端数量'
        this.option.series[0].data = this.terminals
        // console.log(this.terminals)
        this.option.tooltip.formatter = function (params) {
          if (params.data) {
            return '终端数量：' + params.data.value
          } else {
            return '终端数量：0'
          }
        }
      } else {
        this.option.series[0].name = '备案人员数量'
        this.option.series[0].data = this.staffs
        // console.log(this.staffs)
        this.option.tooltip.formatter = function (params) {
          if (params.data) {
            return '备案人员数量：' + params.data.value
          } else {
            return '备案人员数量：0'
          }
        }
      }
      this.fullVisible ? this.loadChart('full_supply') : this.loadChart('supply')
    },
    loadChart(chartId) {
      let chartDom = this.$refs[chartId];
      this.myChart = this.$echarts.init(chartDom);
      // 地图注册，第一个参数的名字必须和option.geo.map一致
      // this.$echarts.registerMap("china", this.mapData)
      this.option.series[0].roam = this.fullVisible
      this.myChart.setOption(this.option);
    },
    fullScreen() {
      this.fullVisible = true
      this.$nextTick(() => {
        this.loadChart('full_supply')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.chart_warp {
  width: 100%;
  height: 100%;
  position: relative;

  .chart_tool {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;

    /deep/.el-button {
      position: absolute;
      right: 0;

      &.tool_icon_btn {
        right: unset;
        left: 0;
        padding: 0;
        width: 32px;
        height: 32px;

        i {
          font-size: 20px;
        }
      }
    }

    /deep/.el-select {
      width: 110px;
      position: absolute;
      right: 0;
    }
  }

  .chart_cont {
    width: 100%;
    height: 100%;
  }
}

/deep/.el-dialog {
  &.big_dialog {
    height: 100%;
    margin: 0;

    .el-dialog__header {
      padding: 10px;
      border-bottom: 1px solid #ddd;

      .el-dialog__headerbtn {
        top: 15px;
      }
    }

    .el-dialog__body {
      padding: 0;
      width: 100%;
      height: calc(100% - 60px);

      .el-select {
        position: absolute;
        right: 1rem;
        top: 4rem;
        z-index: 1;
      }
    }
  }
}
</style>
